"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Upgrade/UpgradeModal/components/PlanInfo.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _cost = require('shared/services/cost');

var _HintToggle = require('web/components/HintToggle'); var _HintToggle2 = _interopRequireDefault(_HintToggle);
var _PlanCardTitle = require('./PlanCardTitle'); var _PlanCardTitle2 = _interopRequireDefault(_PlanCardTitle);












const PlanInfo = ({
  planName,
  orgName,
  planIconSrc,
  desc,
  priceDesc,
  priceHint,
  totalPrice,
  billingFrequency,
}) => (
  _react2.default.createElement('div', { className: "plan-modal--summary--info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
    , _react2.default.createElement('img', { className: "plan-modal--summary--info--icon", src: planIconSrc, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}} )
    , _react2.default.createElement('div', { className: "plan-modal--summary--info--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
      , _react2.default.createElement(_PlanCardTitle2.default, { planName: planName, orgName: orgName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}} )
      , _react2.default.createElement('span', { className: "plan-modal--summary--info--members-count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
        ,  desc 
        ,  priceHint && (
          _react2.default.createElement(_HintToggle2.default, {
            place: "right",
            hint: priceHint,
            className: "plan-modal--summary--info--desc-price--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
          )
        )
      )
      , _react2.default.createElement('span', { className: "plan-modal--summary--info--desc-price", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
        ,  priceDesc 
      )
    )
    , _react2.default.createElement('div', { className: "plan-modal--summary--info--price", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
      , _react2.default.createElement('span', { className: "plan-modal--summary--info--price-tag", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
        ,  _cost.formatDisplayCost.call(void 0, totalPrice) 
      )
      , _react2.default.createElement('span', { className: "plan-modal--summary--info--price-freq", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}},  billingFrequency )
    )
  )
)

exports. default = PlanInfo
